import { Stack, useMantineTheme } from '@mantine/core';
import type { JSX } from 'react';
import React from 'react';

import FundraisingSummaryMetrics from '../FundraisingDashboard/FundraisingSummaryMetrics';
import TransactionTable from '../FundraisingDashboard/TransactionTable';

function FundraisingActivity(): JSX.Element {
  const theme = useMantineTheme();

  return (
    <Stack gap={theme.spacing['4']}>
      <FundraisingSummaryMetrics />
      <TransactionTable />
    </Stack>
  );
}

export default FundraisingActivity;
